import type { MomentumEvent } from './api.js';

// A short reading label; the complete original intelligence line always follows it.
// These topic forms apply to any company/product, without another model call or a stored rewrite.
export function intelligenceHeadline(event: MomentumEvent): string {
  if (event.intelligence && event.headline.trim() !== event.intelligence.text.trim()) return event.headline;
  const text = (event.intelligence?.text ?? event.headline).trim().replace(/\s+/g, ' ');
  let topic: string | undefined;
  const feed = /push opening (?:the )?(.+? feed) to (.+?)(?= from |,|\.|$)/i.exec(text);
  const alternative = /said (.+?) may be a barrier.*?building an? (.+?) as an alternative/i.exec(text);
  const interest = /strong interest from (.+?)(?=,|\.|$)/i.exec(text);
  const data = /(?:and |, )([^,.;]+?) said they are willing to work on how the data flows/i.exec(text);
  if (feed) topic = `${feed[1]} planned for ${feed[2]}`;
  else if (alternative) topic = `${alternative[2]} alternative to ${alternative[1]}`;
  else if (interest && data) topic = `${interest[1]} interest and ${data[1]!.replace(/^and\s+/i, '')} data review`;
  else if (/signed-off addendum/i.test(text) && /licences?/i.test(text)) topic = 'signed-off licence addendum';
  else {
    const authors = event.by.replace(/^(?:Company intelligence|Industry),\s*/i, '').split(/,\s*/);
    let firstClause = text;
    for (const author of authors) {
      if (firstClause.startsWith(`${author} `)) { firstClause = firstClause.slice(author.length + 1); break; }
    }
    firstClause = firstClause.replace(/^sent back (?:the )?/i, '');
    const clause = firstClause.split(/;|,|\.(?:\s|$)|\s+on (?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)\b/i)[0]!.trim();
    const words = clause.split(/\s+/);
    topic = '';
    for (const word of words) {
      if (topic && topic.length + word.length + 1 > 90) { topic += '…'; break; }
      topic += `${topic ? ' ' : ''}${word}`;
    }
  }
  if (!topic) topic = event.intelligence?.origin === 'industry' ? 'industry intelligence' : 'company intelligence';
  return topic.toLowerCase().startsWith(event.deal.company.toLowerCase())
    ? topic : `${event.deal.company}: ${topic}`;
}
